import React from 'react';
import ImageGallery from 'react-image-gallery';
import GalleryData from '../services/GalleryData';

function ChoirGallery({ galleryId }) {
	return <ImageGallery items={GalleryData[galleryId]} />;
}

export default ChoirGallery;
